const en = {
  'welcomeModal.slide1.text': 'Check our Creative Center and choose from the recommendations from Piper or from our hundreds of ready-to-use templates.',
  'welcomeModal.slide2.text': 'Get “Good time to post” recommendations to publish your content, schedule it and organize your content and Ads.',
  'welcomeModal.slide3.text': 'Easily create Social Ads, check their performance and manage your advertising budget.',
  'welcomeModal.slide4.text': '<TryPiperText>Try Social Piper now!</TryPiperText> <TrialText>{trialDays} day-free trial!</TrialText> <TrialHelpText>No risk. Cancel any time. A card is required.</TrialHelpText>',
  'welcomeModal.createAccount.button.text': 'Create account',
};

export default en;
